module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "text-center py-3 bold"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.info.message) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "btn action wide w-100",
    on: {
      "click": _vm.clickedOk
    }
  }, [_vm._v("OK")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afda372a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/richPrompt/templates/invoiceMissingConf.vue
// module id = 2127
// module chunks = 0